import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=1c2af160&"
import script from "./Loader.vue?vue&type=script&setup=true&lang=js&"
export * from "./Loader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=1c2af160&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports